'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducers = undefined;

var _redux = require('redux');

var _pushCartReducer = require('./push-cart-reducer');

var reducers = exports.reducers = (0, _redux.combineReducers)({
  pushCart: _pushCartReducer.pushCartReducer
});